import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=2367f591&scoped=true"
import script from "./selectRole.vue?vue&type=script&lang=js"
export * from "./selectRole.vue?vue&type=script&lang=js"
import style0 from "./selectRole.vue?vue&type=style&index=0&id=2367f591&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367f591",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2367f591')) {
      api.createRecord('2367f591', component.options)
    } else {
      api.reload('2367f591', component.options)
    }
    module.hot.accept("./selectRole.vue?vue&type=template&id=2367f591&scoped=true", function () {
      api.rerender('2367f591', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/position_level_management/form/components/selectRole.vue"
export default component.exports